export default __webpack_public_path__ + "static/media/feedback-icon.1390ada0.svg";